/**
 * 一覧の診療科フィルタの選択をブラウザに残す。
 * 次にアクセスしたときも同じ科で絞り込まれた状態で開くための、端末ローカルな記憶。
 * 保存できない環境（プライベートモードなど）では黙って何もしない。
 */
const STORAGE_KEY = 'medtube:videoList:specialty';

export const loadSpecialtyFilter = (): string => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) ?? '';
  } catch {
    return '';
  }
};

export const saveSpecialtyFilter = (specialtyId: string): void => {
  try {
    if (specialtyId) {
      window.localStorage.setItem(STORAGE_KEY, specialtyId);
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // 保存できなくてもフィルタ自体は動くので握りつぶす
  }
};
